import { Video } from "../types/videos";
import api from "./api";

export const listVideos = async (id: number): Promise<Video[]> => {
  const params = { id_tabloide: id };
  const response = await api.get("lista-ofertas-p1-dev/getVideomatik", {
    params,
  });

  return response.data.response;
};
